import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {NtpServer} from '@/model/system/time/ntpServer';

import {ISystemTimeService} from '@/services/system/ITime.service';
import {Timezone} from '@/model/system/time/timezone';

@Module({name: 'SystemRegionStore', namespaced: true})
export default class SystemRegionStore extends VuexModule {

  @Inject(Symbol.for('ISystemTimeService'))
  private systemTimeService!: ISystemTimeService;

  private datetime: Date | null = null;
  private datetimeRefresh: Date | null = null;
  private timezone: Timezone | null = null;
  private availableTimezones: Timezone[] | null = null;
  private ntpPool: string | null = null;
  private ntpServers: NtpServer[] | null = null;


  /* DATETIME */
  @Action({commit: 'setDatetime', rawError: true})
  public async fetchDatetime() {
    return new Date(await this.systemTimeService.getDatetime());
  }

  @Mutation
  public setDatetime(date: Date) {
    this.datetime = date;
    this.datetimeRefresh = new Date();
  }

  get Datetime(): Date | null {
    return this.datetime;
  }


  /* TIMEZONE */
  @Action({commit: 'setTimezone', rawError: true})
  public async fetchTimezone() {
    return await this.systemTimeService.getTimezone();
  }

  @Mutation
  public setTimezone(timezone: Timezone) {
    this.timezone = timezone;
  }

  get Timezone(): Timezone | null {
    return this.timezone;
  }


  /* AVAILABLE TIMEZONES */
  @Action({commit: 'setAvailableTimezones', rawError: true})
  public async fetchAvailableTimezones() {
    return await this.systemTimeService.getAvailableTimezones();
  }

  @Mutation
  public setAvailableTimezones(timezones: Timezone[]) {
    this.availableTimezones = timezones;
  }

  get AvailableTimezones(): Timezone[] | null {
    return this.availableTimezones;
  }


  /* NTP POOL */
  @Action({commit: 'setNtpPool', rawError: true})
  public async fetchNtpPool() {
    return await this.systemTimeService.getNtpPool();
  }

  @Mutation
  public setNtpPool(ntpPool: string) {
    this.ntpPool = ntpPool;
  }

  get NtpPool(): string | null {
    return this.ntpPool;
  }


  /* NTP SERVERS */
  @Action({commit: 'setNtpServers', rawError: true})
  public async fetchNtpServers() {
    return await this.systemTimeService.getNtpServers();
  }

  @Mutation
  public setNtpServers(servers: NtpServer[]) {
    this.ntpServers = servers;
  }

  get NtpServers(): NtpServer[] | null {
    return this.ntpServers;
  }
}
